import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";

const ROWS = [
  { day: "weekdays", hours: "weekdaysHours" },
  { day: "weekend", hours: "weekendHours" },
  { day: "sunday", hours: "sundayHours" },
];

export default function Schedule() {
  const { t } = useTranslation();

  return (
    <section id="horario" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-3xl px-5 md:px-10">
        <Reveal>
          <h2 className="text-center font-heading text-3xl leading-tight text-foreground-50 md:text-5xl">
            {t("schedule.title")}
          </h2>

          <dl className="mt-10 divide-y divide-background-300/60 overflow-hidden rounded-lg border border-background-300/60 bg-background-50">
            {ROWS.map((row) => (
              <div
                key={row.day}
                className="flex flex-col gap-1 px-5 py-5 sm:flex-row sm:items-baseline sm:justify-between sm:gap-6"
              >
                <dt className="font-body text-base text-foreground-50">
                  {t(`schedule.${row.day}`)}
                </dt>
                <dd className="font-body text-base text-secondary-500">
                  {t(`schedule.${row.hours}`)}
                </dd>
              </div>
            ))}
          </dl>

          <p className="mt-6 font-body text-sm leading-relaxed text-secondary-500">
            {t("schedule.note")}
          </p>
        </Reveal>
      </div>
    </section>
  );
}